import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BookableOfferingService } from '../../bookable-offering.service';
import { BookableOfferingAppointment, WaitListEntry } from '../../models';
import { Observable } from 'rxjs';
import { filter, map, switchMap, throttleTime } from 'rxjs/operators';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { AsyncPipe, DatePipe } from '@angular/common';
import { AppContextRoutePipe } from '../../../app-context/app-context-route.pipe';

@Component({
  selector: 'kgr-active-wait-list-entries',
  templateUrl: './active-wait-list-entries.component.html',
  styleUrls: ['./active-wait-list-entries.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, AsyncPipe, DatePipe, AppContextRoutePipe],
})
export class ActiveWaitListEntriesComponent implements OnInit {
  waitListEntries$: Observable<WaitListEntry[]>;

  constructor(
    private offeringService: BookableOfferingService<BookableOfferingAppointment>,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.waitListEntries$ = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      throttleTime(30000),
      switchMap(() =>
        this.offeringService
          .getWaitListEntries()
          .pipe(
            map((waitListEntries) =>
              waitListEntries.filter((waitListEntry) => this.offeringService.waitListEntryIsCurrentlyBookable(waitListEntry)),
            ),
          ),
      ),
    );
  }
}
